
export async function compressImage(
    blobImg: ImageBitmapSource,
    percent: number,
    maxWidth?: number,
    maxHeight?: number
): Promise<Blob | null> {
    try {
        const bitmap = await createImageBitmap(blobImg);
        const originalWidth = bitmap.width;
        const originalHeight = bitmap.height;

        // If no constraints are set, keep original size
        if (!maxWidth && !maxHeight) {
            maxWidth = originalWidth;
            maxHeight = originalHeight;
        }

        // Compute scaling factors for width and height
        const scaleW = maxWidth ? maxWidth / originalWidth : Infinity;
        const scaleH = maxHeight ? maxHeight / originalHeight : Infinity;

        // Use the **smallest scale** to ensure both dimensions fit
        const scale = Math.min(scaleW, scaleH, 1); // Don’t upscale

        const width = Math.round(originalWidth * scale);
        const height = Math.round(originalHeight * scale);

        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d")!;
        ctx.drawImage(bitmap, 0, 0, width, height);

        const blob = await new Promise<Blob | null>((resolve) => {
            canvas.toBlob(
                (blob) => resolve(blob),
                "image/jpeg",
                percent / 100
            );
        });

        bitmap.close();

        return blob;
    } catch (error) {
        console.error("Error during image compression:", error);
        throw error;
    }
}
